
export const BuyerOrdersList = new TypedDocumentString(`
    query BuyerOrdersList($input: InputPagination!) {
  buyerOrdersList(input: $input) {
    items {
      ...SellerOrderDocItem
      _listingsAll(limit: 3) {
        ...SellerOrderProductsListing
        __typename
      }
      __typename
    }
    info {
      ...PaginationInfo
      __typename
    }
    __typename
  }
}
    fragment ProductPriceLineItem on ProductPriceLineItem {
  qty
  price {
    priceForHumans
    number
    __typename
  }
  ui {
    ...DiscountUi
    __typename
  }
  __typename
}
fragment ProductListingBoxUiPrice on ProductListingBoxUiPrice {
  bulk {
    price
    qty
    __typename
  }
  endAt
  publicCode {
    code
    percent
    price {
      priceForHumans
      number
      __typename
    }
    __typename
  }
  price {
    priceForHumans
    number
    __typename
  }
  priceTaxless {
    priceForHumans
    number
    __typename
  }
  priceOld {
    priceForHumans
    number
    __typename
  }
  lineItems {
    ...ProductPriceLineItem
    __typename
  }
  __typename
}
fragment ProductListingBoxUiPriceFull on ProductListingBoxUiPrice {
  ...ProductListingBoxUiPrice
  _limited {
    limit
    left
    leftPercent
    __typename
  }
  __typename
}
fragment ProductBoxImages on ListingBoxImages {
  id
  slug
  imageBox {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ProductSettingsQty on ProductSettingsQty {
  min
  max
  step
  unit
  stockMsg
  __typename
}
fragment ProductOptionsItem on ProductOptionsItem {
  key
  name
  guideProductId
  guideBodyId
  values {
    name
    hsla {
      ...DocumentColorHsla
      __typename
    }
    image {
      ...ImageNodeItem
      __typename
    }
    product {
      productId
      title
      inStock
      slug
      image {
        ...ImageNodeItem
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment ProductListingValues on ProductListingValues {
  variantCount
  variantAvailableCount
  variantBoxList {
    ...ProductBoxImages
    __typename
  }
  stock
  inStock
  options {
    ...ProductOptionsItem
    __typename
  }
  _uiPrice {
    ...ProductListingBoxUiPriceFull
    __typename
  }
  __typename
}
fragment ProductListingBox on ProductListingBox {
  id
  groupId
  sellerId
  sku
  color
  departmentName
  isNew
  slug
  title
  availabilityType
  availableAt
  quantityLimit
  privateVisibility
  _values {
    ...ProductListingValues
    __typename
  }
  option {
    key
    uiKey
    uiValue
    __typename
  }
  settingsQty {
    ...ProductSettingsQty
    __typename
  }
  rating {
    count
    rating
    __typename
  }
  imageCount
  images {
    ...ImageNodeItem
    __typename
  }
  img1
  returnsNotAllowed
  __typename
}
fragment DiscountUi on DiscountUi {
  msg
  amount
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment PaginationInfo on PaginationInfo {
  pageInfo {
    ...PageInfo
    __typename
  }
  sorting {
    name
    field
    __typename
  }
  filters {
    key
    name
    type
    options {
      number {
        min
        max
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment Duration on Duration {
  unit
  value
  __typename
}
fragment ProductExtraReturn on ProductExtraReturn {
  id
  returnsNotAllowed
  document {
    _id
    __typename
  }
  title {
    value
    __typename
  }
  message {
    value
    __typename
  }
  duration {
    ...Duration
    __typename
  }
  __typename
}
fragment SellerOrderUiStatusValue on SellerOrderUiStatusValue {
  delivery
  order
  payment
  __typename
}
fragment SellerOrderDocProduct on SellerOrderDocProduct {
  qty
  priceUnitFinal {
    priceForHumans
    number
    __typename
  }
  lineItems {
    ...ProductPriceLineItem
    __typename
  }
  priceTotalFinal {
    priceForHumans
    __typename
  }
  returnDoc {
    ...ProductExtraReturn
    __typename
  }
  product {
    id
    title {
      value
      __typename
    }
    image
    imageFull {
      ...Image
      __typename
    }
    description {
      value
      __typename
    }
    departments {
      value
      __typename
    }
    option {
      value
      __typename
    }
    __typename
  }
  __typename
}
fragment SellerOrderProductsListing on SellerOrderProductsListing {
  isAllowToReturn
  qtyAllowedToReturn
  isManual
  returnUntil
  ref {
    ...SellerOrderDocProduct
    __typename
  }
  listing {
    ...ProductListingBox
    __typename
  }
  __typename
}
fragment SellerOrderDocItem on SellerOrderDoc {
  _id
  prettyId
  createdAt
  productCount
  prices {
    ...PaymentPrices
    __typename
  }
  statusDelivery
  statusOrder
  statusPayment
  uiBox {
    isAllowToReturn
    coupon
    address {
      ...BuyerAddress
      __typename
    }
    statusUi
    status {
      status {
        ...SellerOrderUiStatusValue
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment PageInfo on PageInfo {
  totalCount
  totalPageCount
  pageSize
  currentPage
  hasPrevious
  hasNext
  __typename
}
fragment BuyerAddressCountry on BuyerAddressCountry {
  iso2
  __typename
}
fragment BuyerAddress on BuyerAddress {
  _id
  _fullname
  name
  lastname
  street
  apartment
  city
  state
  tel
  postCode
  country {
    ...BuyerAddressCountry
    __typename
  }
  deliveryInstruction
  type
  __typename
}
fragment Price2 on Price2 {
  total {
    priceForHumans
    number
    __typename
  }
  __typename
}
fragment PaymentPrices on PaymentPrices {
  _ui {
    delivery {
      ...Price2
      __typename
    }
    products {
      ...Price2
      __typename
    }
    giftcards {
      ...Price2
      __typename
    }
    final {
      ...Price2
      __typename
    }
    productOld {
      ...Price2
      __typename
    }
    deliveryOld {
      ...Price2
      __typename
    }
    totalSavings {
      ...Price2
      __typename
    }
    taxesPayed {
      ...Price2
      __typename
    }
    taxfull {
      ...Price2
      __typename
    }
    taxfullTaxes {
      ...Price2
      __typename
    }
    taxless {
      ...Price2
      __typename
    }
    taxInfo {
      ...BuyerTaxInfo
      __typename
    }
    isTaxed
    __typename
  }
  __typename
}
fragment BuyerTaxInfo on BuyerTaxInfo {
  iso2
  vatSize
  isTaxed
  goodsForEuCommercialUse
  __typename
}`, {"hash":"c587953730b20594e4781e8d4d159fac0d8d9265f272449438bda071cfc42548"});